var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invoice-report"},[(!_vm.invoiceRows)?_c('div',{staticClass:"invoice-report__loader"},[_c('v-progress-linear',{attrs:{"indeterminate":""}})],1):_vm._e(),(_vm.invoiceRows)?_c('div',{staticClass:"invoice-report__main"},[_c('InvoiceReportTable')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }